__turbopack_context__.v({
  "notification_button": "styles-module-scss-module__nNBQWG__notification_button",
  "notification_card": "styles-module-scss-module__nNBQWG__notification_card",
  "notification_card_content": "styles-module-scss-module__nNBQWG__notification_card_content",
  "notification_card_property": "styles-module-scss-module__nNBQWG__notification_card_property",
  "notification_checkboxes": "styles-module-scss-module__nNBQWG__notification_checkboxes",
  "remove_notification_button": "styles-module-scss-module__nNBQWG__remove_notification_button",
  "remove_notification_modal": "styles-module-scss-module__nNBQWG__remove_notification_modal",
});
